import { enUS } from "../lib/locales.js";
/**
 * Format the month number for the dropdown option label.
 *
 * @defaultValue The localized month name
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
export function formatMonthDropdown( /** The month number to format. */
monthNumber) {
  var _locale$localize;
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : enUS;
  return (_locale$localize = locale.localize) === null || _locale$localize === void 0 ? void 0 : _locale$localize.month(monthNumber);
}